import React from "react";
import { Card } from "@material-ui/core";
import CardHeader from "./_card_header";
import CardData from "./_card_content";

export default function SearchCard({data,searchContent, contentReady}){
    return(
        <Card>
        <CardHeader data={data} searchContent={searchContent} contentReady={contentReady}/>
        <CardData origin={data?.origin} data={data?.data} searchContent={searchContent} contentReady={contentReady}/>
        </Card>
    );
}